import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import { deepEqual } from "../../../utils/object";


class Vehicle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default ?? {},
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }    

    componentDidUpdate(oldProps) {
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default ?? {};
        if (deepEqual(this.state.data, newData)) return;
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
    }

    onChange = (e) => {
        const newData = {
            ...this.state.data,
            [e.target.name]: e.target.value
        };

        if (newData === this.state.data) return;
        
        this.setState({
            data: newData
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    render() {
        return (
            <>
                {this.state.label ?
                    <Row className="g-3">
                        <Col lg="12">
                            <h2 className="small-title">{this.state.label}</h2>
                        </Col>
                    </Row>
                    : ``}
                <Row>
                    <Col lg="4" sm="12">
                        <div className="mb-3 top-label">
                            <Form.Control value={this.state.data.year || ""} type="text" name="year" onChange={this.onChange} readOnly={this.state.locked} />
                            <Form.Label>YEAR</Form.Label>
                        </div>
                    </Col>
                    <Col lg="4" sm="12">
                        <div className="mb-3 top-label">
                            <Form.Control value={this.state.data.make || ""} type="text" name="make" onChange={this.onChange} readOnly={this.state.locked} />
                            <Form.Label>MAKE</Form.Label>
                        </div>
                    </Col>
                    <Col lg="4" sm="12">
                        <div className="mb-3 top-label">
                            <Form.Control value={this.state.data.model || ""} type="text" name="model" onChange={this.onChange} readOnly={this.state.locked} />
                            <Form.Label>MODEL</Form.Label>
                        </div>
                    </Col>
                </Row>
            </>
        )
    }
}

export default Vehicle;